export default "__VITE_ASSET__CxG3e0rF__"